// extracted by mini-css-extract-plugin
export default {"wrap":"ControlConfigDiff_wrap__swe9A","pageContent":"ControlConfigDiff_pageContent__ZaObH","diffValue":"ControlConfigDiff_diffValue__psruf"};